<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.name || userData.email }}
        </p>
<!--        <span class="user-status">{{ userData.roles }}</span>-->
      </div>

      <b-avatar
        size="40"
        :src="userData.avatar"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      >
        <feather-icon
          v-if="!userData.avatar"
          icon="UserIcon"
          size="22"
        />
      </b-avatar>
    </template>


<!--    <b-dropdown-item-->
<!--      :to="{ name: 'account.settings' }"-->
<!--      link-class="d-flex align-items-center"-->
<!--    >-->
<!--      <feather-icon-->
<!--        size="16"-->
<!--        icon="SettingsIcon"-->
<!--        class="mr-50"-->
<!--      />-->
<!--      <span>{{ $t('Settings')}}</span>-->
<!--    </b-dropdown-item>-->
 <b-dropdown-item
      :to="{ name: 'account.settings' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SettingsIcon"
        class="mr-50"
      />
      <span>{{$t('Settings')}}</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>{{ $t('Logout') }}</span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { mapGetters, mapActions } from 'vuex'
import axios from '@axios'
import store from '@/store'
import cookie from '@/api/Csrf'
export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      userData: this.user(),
      avatarText,
    }
  },
  methods: {
    ...mapActions({
      signOut: 'auth/signOut'
    }),
    ...mapGetters({
      user: 'auth/user'
    }),
    logout() {
     
      axios.post('logout').then(res => {
        if (store.state.ws.instance) {
          store.state.ws.instance.close()
          store.dispatch('ws/set', null).then(r => {}).catch(e => console.error('cant reset websocket'))
        }

        if(res.status==204){
          // console.log('rrrrrrrrrrr',res.status)
          cookie.deleteAllCookies()
        this.signOut()
        this.$router.push({ name: 'auth-login' })
        }
        
      }).catch(reason =>  console.log('error on logout'))

    },
  },
}
</script>
